import ConfigurationLoader from 'components/loaders/ConfigurationLoader'
import RetweetControllerComponent from 'components/retweet/RetweetControllerComponent'
import useKeycloakFeatures from 'keycloak/useKeycloakFeatures'
import React from 'react'
import { Outlet } from 'react-router-dom'

export default function Root(): JSX.Element {
  const { isKeycloakInit } = useKeycloakFeatures()

  if (!isKeycloakInit) {
    return <ConfigurationLoader />
  }

  return (
    <>
      <div className="contentContainer">
        <Outlet />
        <RetweetControllerComponent />
      </div>
    </>
  )
}
